import React from 'react';

class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('React render error caught by AppErrorBoundary:', error, errorInfo);
  }

  handleRecover = () => {
    const hasSession = Boolean(window.localStorage.getItem('access_token'));
    window.location.assign(hasSession ? '/dashboard' : '/login');
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-[#FAF9F6] p-6">
          <div className="max-w-md w-full rounded-xl border bg-white p-6 shadow-sm text-center">
            <h1 className="text-xl font-semibold mb-2">Something went wrong</h1>
            <p className="text-sm text-muted-foreground mb-4">
              An unexpected error occurred. Return to the app to continue.
            </p>
            <button
              type="button"
              onClick={this.handleRecover}
              className="inline-flex items-center justify-center rounded-md bg-[#5D7061] px-4 py-2 text-white text-sm font-medium hover:opacity-90"
            >
              Return to {window.localStorage.getItem('access_token') ? 'Dashboard' : 'Login'}
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default AppErrorBoundary;
